/**
 * Umleitung der abgelösten Seiten (Tabelle in `umleitungsTabelle.ts`) und der Hinweis auf den nicht umgeleiteten Alt-Seiten
 * („wird abgelöst → neue Seite", P5 Kern, Till 27.10.2026: bis zur Abnahme erreichbar, nichts wird gelöscht).
 */
import { FC, ReactNode } from 'react';
import { Link as RouterLink, Navigate, useLocation } from 'react-router-dom';
import { Alert, Link } from '@mui/material';
import { umleitungsZiel } from './umleitungsTabelle';

/** Leitet um, wenn die Tabelle ein Ziel kennt; sonst `sonst` (die alte Seite). Query bleibt laut Tabelle erhalten. */
export const Umleitung: FC<{ sonst?: ReactNode }> = ({ sonst = null }) => {
  const { pathname, search } = useLocation();
  const ziel = umleitungsZiel(pathname, search);
  if (ziel) return <Navigate to={ziel} replace />;
  return <>{sonst}</>;
};

/** Hinweis oben auf einer Alt-Seite, die (noch) nicht umgeleitet wird. */
export const AltSeiteHinweis: FC<{ neu: { to: string; label: string }[]; zusatz?: ReactNode }> = ({ neu, zusatz }) => (
  <Alert severity="info" sx={{ m: '20px 20px 0', maxWidth: '100ch' }}>
    <strong>Diese Seite wird abgelöst</strong> und bleibt nur bis zur Abnahme erreichbar →{' '}
    {neu.map((n, i) => (
      <span key={n.to}>
        {i > 0 && ' · '}
        <Link component={RouterLink} to={n.to} underline="hover">
          {n.label}
        </Link>
      </span>
    ))}
    {zusatz ? <> {zusatz}</> : null}
  </Alert>
);
